import { render, staticRenderFns } from "./HousingDashboard.vue?vue&type=template&id=9ce49740&"
import script from "./HousingDashboard.vue?vue&type=script&lang=js&"
export * from "./HousingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports